import { useState, useEffect, useMemo } from "react";
import FilterDataContext from "../Context/FilterDataContext";
import FilterDatesContext from "../Context/FilterDatesContext";

const FilterPanelProvider = ({ children }) => {
    const [filteredData, setFilteredData] = useState(JSON.parse(localStorage.getItem("filteredData")) ?? {});

    const initDates = () => {
        const currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
        const yesterday = String(currentDate.getDate() - 1).padStart(2, '0');
        const departEndCreation = `${currentYear}-${currentMonth}-${yesterday}`;
        if (parseInt(currentMonth) > 5) {
            currentYear += 1;
        }
        const departEnd = `${currentYear}-06-30`;
        if (parseInt(currentMonth) <= 12) {
            currentYear -= 1;
        }
        const departStart = `${currentYear}-07-01`;

        const datesConfig = {
            depart: { start: departStart, end: departEnd, enabled: true },
            creation: { start: '', end: departEndCreation, enabled: true },
            ajoutFacturation: { start: '', end: '', enabled: false },
        }

        localStorage.setItem('defaultDates', JSON.stringify(datesConfig));

        return datesConfig;
    };

    const [dates, setDates] = useState(() => {
        const storedDates = localStorage.getItem('dates');
        return storedDates ? JSON.parse(storedDates) : initDates();
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        localStorage.setItem('dates', JSON.stringify(dates));
    }, [dates]);

    useEffect(() => {
        if (filteredData && Object.keys(filteredData).length > 0) {
            localStorage.setItem('filteredData', JSON.stringify(filteredData));
        } else {
            localStorage.removeItem('filteredData');
        }
    }, [filteredData]);

    const filterDataValue = useMemo(() => ({
        filteredData,
        setFilteredData
    }), [filteredData]);

    const filterDatesValue = useMemo(() => ({
        dates,
        setDates,
        errors,
        setErrors
    }), [dates, errors]);

    return (
        <FilterDataContext.Provider value={filterDataValue}>
            <FilterDatesContext.Provider value={filterDatesValue}>
                {children}
            </FilterDatesContext.Provider>
        </FilterDataContext.Provider>
    );
};

export default FilterPanelProvider;
